import React, { Component, ErrorInfo, ReactNode } from 'react'
import { Box, Typography, Button, Container } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

interface Props {
	children: ReactNode
	fallback?: ReactNode
}

interface State {
	hasError: boolean
	error: Error | null
}

class ErrorBoundary extends Component<Props, State> {
	constructor(props: Props) {
		super(props)
		this.state = { hasError: false, error: null }
	}

	static getDerivedStateFromError(error: Error): State {
		return { hasError: true, error }
	}

	componentDidCatch(error: Error, info: ErrorInfo) {
		console.error('[ErrorBoundary] Перехвачена ошибка рендеринга:', error, info)
	}

	render() {
		if (this.state.hasError) {
			if (this.props.fallback) return this.props.fallback

			return (
				<Container maxWidth='sm'>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center',
							minHeight: '300px',
							gap: 2,
							textAlign: 'center',
						}}
					>
						<ErrorOutlineIcon sx={{ fontSize: 64, color: 'error.main' }} />
						<Typography variant='h6' color='error'>
							Что-то пошло не так
						</Typography>
						<Typography variant='body2' color='text.secondary'>
							Произошла ошибка при отображении страницы. Попробуйте обновить.
						</Typography>
						<Button
							variant='contained'
							onClick={() => window.location.reload()}
						>
							Обновить страницу
						</Button>
					</Box>
				</Container>
			)
		}

		return this.props.children
	}
}

export default ErrorBoundary
